<template>
  <div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <el-collapse v-model="show1" class="leftItem">
          <el-collapse-item name="1">
            <template slot="title">
              <div
                style="
                  padding: 0 29px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div style="float: left; margin-right: 16px">
                  <img src="../../assets/images/billdz.png" alt="地址" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    color: black;
                  "
                >
                  地址信息
                </div>
              </div>
            </template>
            <div class="semillWrap" style="margin-top: 20px; padding: 0 40px">
              <div style="width: 100%; float: left">
                <div style="padding: 10px 0 0 25px; box-sizing: border-box">
                  <el-form
                    label-position="left"
                    label-width="85px"
                    :model="THFdata"
                  >
                    <el-form-item label="收货信息">
                      <div class="block">
                        FBA仓库编码：{{ toFABck.namec }}
                        <div>
                          <span class="el-icon-location-information"></span
                          >{{ toFABck.address }}
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="发货信息">
                      <div class="block">
                        <el-radio-group
                          @change="changeTi"
                          v-model="THFdata.checked"
                        >
                          <el-radio-button :label="true"
                            >上门取件</el-radio-button
                          >
                          <el-radio-button :label="false"
                            >送货到仓</el-radio-button
                          >
                        </el-radio-group>
                      </div>
                    </el-form-item>
                  </el-form>
                  <!-- 送货到仓 -->
                  <el-form
                    size="small"
                    label-width="85px"
                    label-position="left"
                    :inline="true"
                    class="demo-form-inline"
                  >
                    <el-row style="float: left" :gutter="20">
                      <el-col :span="24" v-show="!THFdata.checked">
                        <el-form-item label="送仓日期">
                          <div class="block">
                            <el-date-picker
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              style="width: 344px"
                              v-model="inwarehousetime"
                              type="date"
                              placeholder="选择日期"
                              :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="!THFdata.checked">
                        <el-form-item label="仓库联系人">
                          <el-input
                            disabled
                            v-model="itemWrap.warehouseContactPerson"
                            style="width: 240px"
                            class="input-with-select"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="THFdata.checked">
                        <el-form-item label="提货地点">
                          <el-input
                            v-model="
                              countLIst_T.parvince +
                              countLIst_T.city +
                              countLIst_T.area +
                              countLIst_T.address
                            "
                            style="width: 240px"
                            class="input-with-select"
                          >
                            <el-button
                              style="color: #FF4D01"
                              @click="changeCheic()"
                              slot="append"
                              >联系簿</el-button
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="!THFdata.checked">
                        <el-form-item label="仓库地址">
                          <el-popover
                            placement="top-start"
                            title="仓库地址"
                            width="200"
                            trigger="hover"
                            :content="itemWrap.warehouseAddress"
                          >
                            <el-input
                              disabled
                              slot="reference"
                              v-model="itemWrap.warehouseAddress"
                              class="input-with-select"
                            ></el-input>
                          </el-popover>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="THFdata.checked">
                        <el-form-item label="提货日期">
                          <el-date-picker
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 220px"
                            v-model="todoorTime"
                            type="date"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="发货联系人">
                          <el-input
                            v-model="countLIst_S.name"
                            style="width: 240px"
                            class="input-with-select"
                          >
                            <el-button
                              style="color: #FF4D01"
                              @click="getFadata()"
                              slot="append"
                              >联系簿</el-button
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="联系电话">
                          <el-input
                            v-model="countLIst_S.tel"
                            class="input-with-select"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="show2" class="leftItem">
          <el-collapse-item name="1">
            <template slot="title">
              <div style="padding: 0 29px">
                <div style="float: left; margin-right: 16px">
                  <img src="../../assets/thicon.png" alt="货物" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    color: black;
                  "
                >
                  货物信息
                </div>
              </div>
            </template>
            <div style="width: 100%; float: left">
              <!-- ref="ruleform"  取消校验  导入箱子(12位) -->
              <div style="margin-left: 40px">
                <el-button
                  size="medium"
                  type="primary"
                  @click="(excelVisible = true), (errorLabel = [])"
                  :close-on-click-modal="false"
                  >导入箱子<i class="el-icon-upload el-icon--right"></i
                ></el-button>

                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top-start"
                  style="margin-right: 10px"
                >
                  <div slot="content">
                    系统会自动根据箱数和FBAID生成对应的箱号<br />
                    输出比如FBA15M7CJDZN箱数为3，系统会自动生成对应的箱号明细数据<br />
                    FBA15M7CJDZU000001<br />
                    FBA15M7CJDZU000002<br />
                    FBA15M7CJDZU000003<br />
                    注：如果使用页面录入货物信息，需录入对应箱子信息
                  </div>
                  <span
                    style="font-size: 14px; color: #f9a123"
                    class="el-icon-question"
                  ></span>
                </el-tooltip>

                <!-- <el-button
                  size="medium"
                  type="primary"
                  @click="(excelVisibleUpadte = true), (errorLabel = [])"
                  :close-on-click-modal="false"
                  >导入箱子(19位)<i class="el-icon-upload el-icon--right"></i
                ></el-button> -->

              </div>
              <el-form
                label-position="left"
                class="demo-dynamic"
                size="mini"
                :model="ruleform"
                ref="ruleform"
              >
                <div
                  class="cardWrap"
                  v-for="(item, index) in ruleform.formLIst"
                  :key="index"
                >
                  <div class="box-card">
                    <div class="card_header">
                      <div class="boxindex">
                        {{ index + 1 }}
                      </div>
                      <div class="header_logo" style="cursor: pointer">
                        <div class="cloneType" @click="clone(item)">复制</div>
                        <div
                          class="deleteBtn"
                          v-if="ruleform.formLIst.length > 1"
                          @click="handleDelete(index, item)"
                        >
                          <i class="el-icon-error"></i>
                        </div>
                      </div>
                      <div class="">
                        <el-row :gutter="5" class="">
                          <el-col :span="12">
                            <el-col :span="12">
                              <el-form-item
                                label="尺寸(CM)"
                                label-width="86px"
                                class="rules"
                                :prop="'formLIst.' + index + '.length'"
                                :rules="moreNotOjb.Notlength"
                              >
                                <el-input
                                  placeholder="长"
                                  size="mini"
                                  :min="0"
                                  :max="9999"
                                  v-model="item.length"
                                  @change="
                                    getTimoney(index), getFBATrans(index)
                                  "
                                ></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="6">
                              <el-form-item
                                class="rules"
                                label-width="5px"
                                :prop="'formLIst.' + index + '.width'"
                                :rules="moreNotOjb.Notwidth"
                              >
                                <el-input
                                  placeholder="宽"
                                  size="mini"
                                  :min="0"
                                  :max="9999"
                                  v-model="item.width"
                                  @change="
                                    getTimoney(index), getFBATrans(index)
                                  "
                                >
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="6">
                              <el-form-item
                                label-width="5px"
                                class="rules"
                                :prop="'formLIst.' + index + '.height'"
                                :rules="moreNotOjb.Notheight"
                              >
                                <el-input
                                  placeholder="高"
                                  size="mini"
                                  :min="0"
                                  :max="9999"
                                  v-model="item.height"
                                  @change="
                                    getTimoney(index), getFBATrans(index)
                                  "
                                >
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-col>
                          <el-col :span="5">
                            <div
                              class="LR_center"
                              style="
                                font-size: 12px;
                                font-weight: bold;
                                text-align: left;
                                margin-top: 8px;
                              "
                            >
                              <div style="">
                                <span style="color: #f86670">{{
                                  item.cbm
                                }}</span
                                >CBM
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div class="card_count">
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item
                            class="rules"
                            label-width="95px"
                            label="客户箱号"
                            :rules="moreNotOjb.Notboxnum"
                            :prop="'formLIst.' + index + '.fbxBoxNo'"
                          >
                            <el-input
                              maxlength="19"
                              type="text"
                              :placeholder="
                                billType
                                  ? '示例：FBAXXXXX (共19位)'
                                  : '请输入箱号'
                              "
                              v-model="item.fbxBoxNo"
                              size="mini"
                            >
                              <el-button
                                v-if="billType"
                                slot="suffix"
                                @click="(imageNum = 1), (imagesType = true)"
                                type="text"
                                >示例图</el-button
                              >
                            </el-input>
                          </el-form-item>
                          <span class="Shipment">(Shipment ID)</span>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item
                            label-width="95px"
                            class="rules"
                            label="重量"
                            :prop="'formLIst.' + index + '.weight'"
                            :rules="moreNotOjb.Notweight"
                          >
                            <el-input
                              size="mini"
                              @change="getTimoney(), getFBATrans(index)"
                              :min="0"
                              :max="999"
                              v-model="item.weight"
                              placeholder="请输入重量"
                            >
                              <i slot="suffix">(KG)</i>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col
                          :span="12"
                          v-if="billType && toFABck.countryCode == 'SA'"
                        >
                          <el-form-item
                            class="rules"
                            label-width="95px"
                            label="商铺编号"
                            :prop="'formLIst.' + index + '.shopName'"
                            :rules="moreNotOjb.Notgoodsnum"
                          >
                            <el-input
                              v-model="item.shopName"
                              size="mini"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col
                          :span="12"
                          v-if="
                            (billType && toFABck.countryCode == 'SA') ||
                            (billType && toFABck.countryCode == 'US') ||
                            (billType && toFABck.countryCode == 'GB') ||
                            (billType && toFABck.countryCode == 'CA') ||
                            (billType && toFABck.countryCode == 'EU')
                          "
                        >
                          <el-form-item
                            class="rules"
                            label-width="110px"
                            label="货件追踪编号"
                            :prop="'formLIst.' + index + '.poTrackingNo'"
                            :rules="moreNotOjb.Notponum"
                          >
                            <el-input
                              size="mini"
                              maxlength="8"
                              v-model="item.poTrackingNo"
                              placeholder="示例：618T8E8X"
                            >
                              <el-button
                                slot="suffix"
                                @click="(imageNum = 2), (imagesType = true)"
                                type="text"
                                >示例图</el-button
                              >
                            </el-input>
                          </el-form-item>
                          <span class="ShipmentID">(Reference ID)</span>
                        </el-col>
                      </el-row>
                    </div>
                    <div
                      style="
                        width: 100%;
                        padding: 5px 20px;
                        box-sizing: border-box;
                      "
                    >
                      <el-collapse
                        @change="handleOPen(index)"
                        v-model="activeName"
                        style="float:left:width:100%"
                      >
                        <el-collapse-item :name="index">
                          <template slot="title">
                            <i class="el-icon-coin"></i>
                            <span
                              style="
                                margin-left: 15px;
                                font-size: 13px;
                                font-weight: bold;
                              "
                              >{{ item.goodsDTOList.length }}箱商品</span
                            >
                            <span
                              class="el-icon-info"
                              style="
                                margin-left: 30px;
                                font-size: 12px;
                                color: #999;
                              "
                              >请根据实际情况填写商品货值</span
                            >
                          </template>
                          <div
                            @click="clickme(_item)"
                            class="goodLi"
                            style="width: 100%"
                            v-for="(_item, _index) in item.goodsDTOList"
                            :key="_index"
                          >
                            <div style="width: 30px; float: left">
                              <i
                                style="font-size: 18px"
                                class="el-icon-shopping-cart-1"
                              ></i>
                            </div>
                            <div
                              style="
                                width: 280px;
                                float: left;
                                overflow: hidden;
                                color: #999999;
                                font-weight: bold;
                                font-size: 12px;
                              "
                            >
                              <span style="width: 100px"
                                >{{ _item.namec }}
                              </span>
                              <span style="margin-left: 10px"
                                >({{ _item.namee }})</span
                              >
                            </div>
                            <div
                              style="float: left; margin-left: 10px"
                              class="handNumber"
                            >
                              <el-input
                                size="mini"
                                v-model.number="_item.num"
                                type="number"
                                minlength="1"
                                maxLength="9"
                                oninput="if(isNaN(value)) { value = null } if(value<=0) {value=null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                              >
                                <i
                                  slot="suffix"
                                  class="el-input__icon el-icon-plus"
                                  @click="(_item.num += 1), Changehandle()"
                                ></i>
                                <i
                                  slot="prefix"
                                  class="el-input__icon el-icon-minus"
                                  @click="
                                    (_item.num -= 1),
                                      _item.num <= 1 ? (_item.num = 1) : '',
                                      Changehandle()
                                  "
                                ></i>
                              </el-input>
                            </div>
                            <div
                              class="goodsValue"
                              style="float: left; margin-left: 10px"
                            >
                              <span style="color: #999">货值(USD)</span>
                              <el-input
                                style="width: 150px; border: none"
                                size="mini"
                                v-model="_item.declaredValue"
                                placeholder="货值"
                              >
                              </el-input>
                            </div>
                            <div style="float: left; margin-left: 10px">
                              <el-button
                                class="el-icon-delete"
                                style="color: #f86670"
                                type="text"
                                size="mini"
                                @click="delBoxgood(index, _index)"
                                >删除</el-button
                              >
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                      <!-- 折叠END -->
                      <div class="addStyle">
                        <el-button
                          plain
                          icon="el-icon-circle-plus-outline"
                          size="mini"
                          style="border-radius: 2px"
                          circle
                          @click="changegoods(index)"
                          >选择商品</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </el-form>
              <!-- demo 测试 END -->
            </div>
            <div
              style="width: 35%; float: left; padding: 30px"
              class="LR_center"
            >
              <div>
                <el-button size="medium" @click="addItem('ruleform')"
                  >+新增箱子</el-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="show3" class="leftItem">
          <el-collapse-item name="1">
            <template slot="title">
              <div style="padding: 0 29px">
                <div style="float: left; margin-right: 16px">
                  <img src="../../assets/style.png" alt="增值服务" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    color: black;
                  "
                >
                  增值服务
                </div>
              </div>
            </template>
            <div
              class="Item_list"
              v-for="(item, index) in formData.feeItemDTOS"
              :key="index"
            >
              <div style="width: 100%">
                <el-checkbox
                  v-model="item.checked"
                  @change="Changehandle(item)"
                  >{{ item.feeName }}</el-checkbox
                >
                <el-tooltip
                  v-show="item.feeDescription"
                  class="item"
                  effect="dark"
                  :content="item.feeDescription"
                  placement="top-start"
                >
                  <span
                    style="font-size: 14px; color: #f9a123"
                    class="el-icon-question"
                  ></span>
                </el-tooltip>
              </div>
              <div
                class="LR_center"
                style="width: 100%; float: left"
                v-show="item.checked"
              >
                <div
                  class="count_center"
                  style="padding: 25px 25px 0 25px; box-sizing: border-box"
                >
                  <span style="float: left">{{ item.priceDesc }}</span>
                  <div
                    style="float: left; margin-left: 15px"
                    v-show="item.feeCode != 'FB003' && item.feeCode != 'FB019'"
                  >
                    <el-input-number
                      size="mini"
                      v-model="item.num"
                      @change="Changehandle(item)"
                      :min="1"
                      :max="9999"
                    ></el-input-number>
                  </div>
                </div>
              </div>
              <div
                v-if="item.remark && item.checked"
                style="float: right; color: #ccc; padding-right: 25px"
              >
                *{{ item.remark }}
              </div>
            </div>
            <div
              v-show="formData.feeItemDTOS.length == 0"
              style="padding: 20px"
            >
              <el-alert
                :closable="false"
                title="该线路暂无增值服务"
                type="warning"
                description="该线路暂无增值服务"
                show-icon
              >
              </el-alert>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          物流产品信息
        </p>

        <div class="Item_Right animate__animated animate__bounceInRight">
          <div class="header_text">
            <p class="coutText">
              <span class="littit">物流产品</span>
              <span class="fontString"
                >{{ itemWrap.productName
                }}{{ itemWrap.containsTheTariffs ? "包税" : "不包税" }}</span
              >
            </p>
            <p class="coutText">
              <span class="littit">整体时效</span>
              <span class="fontString">{{ itemWrap.aging }}</span>
            </p>
            <p class="coutText" v-show="itemWrap.volumeWeightRatio">
              <span class="littit">体积重比率</span>
              <span class="fontString">{{ itemWrap.volumeWeightRatio }}</span>
            </p>
            <p class="coutText" v-show="itemWrap.weightVolumeRatioDesc">
              <span class="littit">重量转换</span>
              <span class="fontString">{{
                itemWrap.weightVolumeRatioDesc
              }}</span>
            </p>
            <p class="coutText">
              <span class="littit">可接货物类型：</span>
              <span class="fontString">{{ itemWrap.goodsTypeNames }}</span>
            </p>
          </div>
          <el-divider></el-divider>
          <div class="header_text">
            <p class="coutText">
              <span class="littit">总箱数</span>
              <span class="fontString">{{ ruleform.formLIst.length }}(箱)</span>
            </p>
            <p class="coutText">
              <span class="littit">总PCS</span>
              <span class="fontString">{{ getBoxpcs }}(件)</span>
            </p>
            <p class="coutText">
              <span class="littit">总体积</span>
              <span class="fontString">{{ getboxwhere }}(CBM)</span>
            </p>
            <p class="coutText">
              <span class="littit">总重量</span>
              <span class="fontString">{{ getboxWeight }}(KG)</span>
            </p>
            <p class="coutText">
              <span class="littit">计费重</span>
              <span class="fontString">{{ FBATransmoney.chargeWeight }}</span>
            </p>
          </div>
        </div>
        <div class="Item_Right">
          <!-- <p class="tit">运输费</p> -->
          <p
            class="coutText"
            v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
            :key="index"
          >
            <span class="littit">{{ item.goodsTypeName }}</span>
            <span class="fontString">{{ item.currency }}{{ item.amount }}</span>
            <span style="margin-left: 10px">({{ item.calDesc }})</span>
          </p>
          <p
            class="coutText animate__animated animate__bounceInRight"
            v-show="THFdata.checked && THFdata.amount"
          >
            <span class="littit">提货费</span>
            <span class="fontString"
              >{{ THFdata.currency }}{{ THFdata.amount }}</span
            >
          </p>
          <div v-if="calFBAFeeIDTOS.amount">
            <div
              class="coutText animate__animated animate__bounceInRight"
              v-for="(item, index) in calFBAFeeIDTOS.feeDTOList"
              :key="index"
            >
              <span class="littit">{{ item.feeName }}</span>
              <span class="fontString">{{ item.calDesc }}</span>
            </div>
          </div>
          <!-- <div class="coutText animate__animated animate__bounceInRight" style="color: #ff3030">
              <span class="littit" style="color: #ff3030">小计:</span>
              <span class="fontString">CNY {{ calFBAFeeIDTOS.amount }}</span>
            </div> -->
        </div>
        <div class="Item_Right">
          <p class="">
            <span class="littit">合计费用</span>
            <span
              v-for="(item, index) in this.newArray"
              :key="index"
              v-show="item.amount > 0"
            >
              <span
                ><span class="fontString" v-show="item.currency != ''">{{
                  item.currency
                }}</span>
                <span
                  class="fontString"
                  v-show="item.amount > 0"
                  style="margin-left: 5px; margin-right: 5px"
                  >{{ item.amount }}</span
                ></span
              >
              <span v-show="index == newArray.length - 1 ? false : true"
                >+</span
              >
            </span>
          </p>
          <p class="coutText">
            <span class="littit">折合人民币</span>
            <span class="fontString">CNY {{ calculatePrice }}</span>
          </p>
        </div>
        <div style="width: 100%; margin-top: 56px; float: left">
          <!-- <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()"
              >上一步</el-button
            >
          </div> -->
          <div style="width: 100%; margin-top: 10px">
            <el-button
              style="width: 100%; background: #FF4D01; color: #ffffff"
              @click="pathToNext('ruleform')"
              >提交订单</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 -->
    <div class="dialogCover" @click.self="closeMyDialog()" v-if="showMydialog">
      <div class="myDialog">
        <!-- header  -->
        <div style="display: flex; justify-content: space-between">
          <span style="font-weight: 600">提货地址</span>
          <i
            class="el-icon-close"
            @click="closeMyDialog()"
            style="cursor: pointer"
          ></i>
        </div>
        <!-- body   -->
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 20px 0;
            "
          >
            <div>
              <el-input
                clearable
                @clear="getPeopletable()"
                v-model="nameOrPhone"
                @keyup.native="searchNameOrPhone"
                placeholder="请输入姓名或电话"
                size="medium"
                style="width: 250px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" type="primary">搜索</el-button>
              </el-input>
            </div>

            <el-button size="medium" plain type="primary" @click="showAdd(true)"
              >新增地址</el-button
            >
          </div>
          <!-- 新增或编辑 -->
          <div
            v-if="edit"
            style="
              background-color: #fff;
              border-radius: 20px;
              padding: 20px;
              box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
            "
          >
            <div style="width: 85%; margin: 0 auto; max-width: 500px">
              <el-row
                :gutter="20"
                style="margin-bottom: 8px; margin-left: 1px; display: flex"
              >
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="margin-right: 35px; min-width: 50px"
                  >
                    <span style="line-height: 40px">联系人</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.name"
                      placeholder="请输入联系人"
                    ></el-input>
                  </div>
                </div>
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="
                      margin-left: 10px;
                      margin-right: 10px;
                      min-width: 60px;
                    "
                  >
                    <span style="line-height: 40px">联系方式</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.tel"
                      placeholder="请输入联系方式"
                    ></el-input>
                  </div>
                </div>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">联系地址</span>
                  </div></el-col
                >
                <el-col :span="18">
                  <div class="grid-content">
                    <el-cascader
                      :options="jackCitylist"
                      placeholder="请选择提货地址"
                      v-model="value"
                      clearable
                      @change="handleChange"
                      :props="props"
                    >
                    </el-cascader>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <div
                      style="line-height: 40px; width: 10px; height: 10px"
                    ></div></div
                ></el-col>
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.address"
                      type="textarea"
                      rows="2"
                      placeholder="请输入详细地址"
                    ></el-input></div
                ></el-col>
              </el-row>
              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">标签</span>
                  </div></el-col
                >
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.tag"
                      placeholder="请输入标签"
                    ></el-input></div
                ></el-col>
              </el-row>

              <div style="width: 330px; margin: 0 auto; text-align: center">
                <div style="display: flex">
                  <el-checkbox
                    text-color="#FF4D01"
                    v-model="submitForm.isdefault"
                    style="margin-right: 10px"
                  ></el-checkbox>
                  <span style="display: block; margin-bottom: 8px">
                    设置为默认地址
                  </span>
                </div>
                <el-button
                  @click="addAddr"
                  style="
                    background: #FF4D01;
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                    color: #fff;
                  "
                  >{{ this.submitForm.id ? "修改" : "新增" }}</el-button
                >
                <el-button type="info" @click="showAdd(false)">关闭</el-button>
              </div>
            </div>
          </div>

          <el-table
            v-if="!edit"
            @row-click="rowClick"
            size="mini"
            height="300"
            tooltip-effect="dark"
            :data="tableData"
            max-height="200"
            highlight-current-row
            border
            ref="Table"
            style="width: 100%; overflow: hidden"
          >
            <el-table-column
              label="姓名"
              width="100"
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column label="电话" width="120" align="center" prop="tel">
            </el-table-column>
            <el-table-column
              label="联系地址"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.parvince }}
                {{ scope.row.city }}
                {{ scope.row.area }}
                {{ scope.row.address }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="160">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="setDefault(scope.row)"
                >
                  <span
                    :style="
                      scope.row.isdefault ? 'color:#FF4D01' : 'color:#9A9A9A'
                    "
                    >{{ scope.row.isdefault ? "默认" : "设为默认" }}</span
                  >
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="DeleteTitem(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="!edit"
            style="margin-top: 20px"
            title="点击任意一行选择您的地址"
            type="info"
            center
            show-icon
          >
          </el-alert>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 END -->
    <!-- 商品列表 -->
    <el-dialog title="商品列表" width="950px" :visible.sync="goodsTypeShow">
      <div class="typeHeader LR_center">
        <div>
          <el-input
            style="width: 314px"
            placeholder="请输入中文品名"
            v-model="Sgodname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              type="primary"
              @click="getgoodsData(Sgodname)"
              >搜索</el-button
            >
          </el-input>
        </div>
        <div>
          <el-select
            clearable
            style="width: 100%"
            ref="changeFBAgoodtype"
            placeholder="请选择商品类型"
            v-model="ThatgoodsID"
            @change="getgoodsData(Sgodname)"
          >
            <el-option
              v-for="res in goodstypelist"
              :key="res.id"
              :label="res.cnName"
              :value="res.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            @click="addgoods()"
            >新增商品</el-button
          >
          <!-- <el-button type="primary" icon="el-icon-download" plain
            >导入商品</el-button
          > -->
        </div>
      </div>

      <div class="countTable" style="margin-top: 30px">
        <el-table
          ref="multipleTable"
          border
          :data="goodsLabel"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="中文名称" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.namec }}</template>
          </el-table-column>
          <el-table-column
            prop="namee"
            label="英文品名"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="materialc" align="center" label="材质">
          </el-table-column>
          <el-table-column prop="purposec" align="center" label="用途">
          </el-table-column>
          <el-table-column prop="hsCode" align="center" label="海关编码">
          </el-table-column>
          <el-table-column prop="goodstype" align="center" label="货物类型">
          </el-table-column>
          <el-table-column prop="goodstype" align="center" label="是否带电">
            <template slot-scope="scope">
              {{ scope.row.isHasBattery ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="是否带磁" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.isHasMagnetic ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodstype"
            align="center"
            label="是否液体/粉末"
          >
            <template slot-scope="scope">
              {{ scope.row.isPowderLiquid ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="商品图片" align="center" prop="">
            <template slot-scope="scope">
              <div v-viewer>
                <img
                  v-if="scope.row.picUrl"
                  :src="scope.row.picUrl"
                  style="width: 50px; height: 50px"
                  class="table-column__goods-cover"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="销售链接" align="center" prop="salesUrl">
            <template slot-scope="scope">
              <a
                v-if="scope.row.salesUrl"
                class="el-link el-link--info"
                :href="scope.row.salesUrl"
                target="_blank"
              >
                {{ scope.row.salesUrl }}
              </a>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope" v-if="scope.row.customerid">
              <el-button
                type="text"
                size="mini"
                @click="goodsEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                style="color: red"
                @click="delGoodItem(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="goodslisttotal"
          ></el-pagination>
        </div>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-button type="primary" @click="setGoodspush()">确认选择</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 新增编辑商品弹窗 -->
    <el-dialog
      title="商品新增"
      :visible.sync="goodstextShow"
      width="850px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="width: 100%">
        <el-form
          size="small"
          ref="addgoodform"
          :model="addgoodform"
          :rules="goodsRules"
          label-width="110px"
          class="goodsTextFlex"
        >
          <div style="width: 45%">
            <el-form-item style="width: 100%" label="中文品名" prop="namec">
              <el-input
                placeholder="请输入中文品名"
                v-model="addgoodform.namec"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="goodstypeid"
              style="width: 100%"
              label="商品类型"
            >
              <el-select
                clearable
                style="width: 100%"
                ref="changeFBAgoodtype"
                placeholder="请选择商品类型"
                v-model="addgoodform.goodstypeid"
              >
                <el-option
                  v-for="res in goodstypelist"
                  :key="res.id"
                  :label="res.cnName"
                  :value="res.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width: 100%" label="品牌" prop="brand">
              <el-input
                placeholder="请输入商品品牌"
                v-model="addgoodform.brand"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="海关编码" prop="hsCode">
              <el-input
                placeholder="请输入海关编码"
                v-model="addgoodform.hsCode"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="用途" prop="purposec">
              <el-input
                style="width: 100%"
                placeholder="请输入用途"
                v-model="addgoodform.purposec"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="是否带磁"
              prop="isHasMagnetic"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isHasMagnetic"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width: 100%" label="销售链接" prop="salesUrl">
              <el-input
                placeholder="请输入销售链接"
                v-model="addgoodform.salesUrl"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="图片上传" prop="picUrl">
              <el-upload
                ref="uploadDemo"
                drag
                multiple
                class="upload-demo"
                :action="''"
                :limit="1"
                :show-file-list="false"
                :auto-upload="false"
                accept="image/jpeg,image/jpg,image/png"
                :on-change="handleAvatarChange"
              >
                <img
                  v-if="addgoodform.picUrl"
                  :src="addgoodform.picUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div style="width: 45%">
            <el-form-item prop="namee" style="width: 100%" label="英文品名">
              <el-input
                style="width: 100%"
                placeholder="请输入英文品名"
                v-model="addgoodform.namee"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="型号" prop="model">
              <el-input
                placeholder="请输入商品型号"
                v-model="addgoodform.model"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="货值(USD)"
              prop="declaredValue"
            >
              <el-input
                placeholder="请输入商品货值"
                type="number"
                v-model.number="addgoodform.declaredValue"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="材质" prop="materialc">
              <el-input
                placeholder="请输入材质"
                v-model="addgoodform.materialc"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="是否带电"
              prop="isHasBattery"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isHasBattery"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="是否液体/粉末"
              prop="isPowderLiquid"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isPowderLiquid"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div
          style="width: 100%; padding: 30px; box-sizing: border-box"
          class="TB_center"
        >
          <el-button type="primary" @click="addgoodtext('addgoodform')">{{
            GoodsCategory ? "确认新增" : "确认修改"
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增编辑商品弹窗END -->

    <!-- Excel-12位上传 -->
    <el-dialog title="文件上传" :visible.sync="excelVisible" width="40%" center>
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :http-request="uploadSectionFile"
        class="upload-demo"
        drag
        action=""
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="helper">如需提供帮助，请致电400-992-1818</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          size="mini"
          @click="excelVisible = false"
          >取 消</el-button
        >
        <el-link target="_blank">
          <el-button size="mini" type="success" @click="Getdown()"
            >下载模板</el-button
          >
        </el-link>
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <!-- Excel-19位上传 -->
    <!-- <el-dialog
      title="文件上传"
      :visible.sync="excelVisibleUpadte"
      width="40%"
      center
    >
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleErrorUpdate"
        :on-success="handleSuccessUpdate"
        :before-upload="handleBeforeUploadXls"
        :http-request="uploadSectionFileUpdate"
        class="upload-demo"
        drag
        action=""
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="helper">如需提供帮助，请致电400-992-1818</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          size="mini"
          @click="excelVisibleUpadte = false"
          >取 消</el-button
        >
        <el-link target="_blank">
          <el-button size="mini" type="success" @click="Getdown()"
            >下载模板</el-button
          >
        </el-link>
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog> -->

    <!-- 示例图 -->
    <el-dialog title="示例图" :visible.sync="imagesType" width="600px" center>
      <img
        v-show="imageNum == 1"
        src="../../../static/images/boxdemo.png"
        alt="FBA纸箱编号示例图"
      />
      <img
        v-show="imageNum == 2"
        src="../../../static/images/ponum.png"
        alt="补/发货示例图"
      />
    </el-dialog>

    <!-- 发货人 -->
    <el-dialog title="发货联系人" :visible.sync="fashow">
      <div
        style="
          width: 100%;
          float: left;
          text-align: right;
          padding: 10px 25px;
          box-sizing: border-box;
        "
      >
        <el-button type="primary" @click="addNewpop()">新增地址</el-button>
      </div>
      <!-- FapopList -->
      <el-table size="mini" @row-click="rowFaset" :data="FapopList">
        <el-table-column
          property="name"
          label="姓名"
          width="200"
        ></el-table-column>
        <el-table-column property="tel" label="电话"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click.stop="UpItem(scope.row)" type="text" size="small"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        title="点击任意一行选择您的地址"
        center
        style="margin-top: 20px"
        show-icon
        :closable="false"
      ></el-alert>
    </el-dialog>

    <el-dialog
      class="dialog"
      :width="width"
      :visible.sync="fahuoShow"
      :closeOnClickModal="false"
    >
      <div class="wrap_count">
        <div class="fa_logo">
          {{ !this.itemid ? "新增地址" : "修改地址" }}
        </div>
        <div class="count">
          <el-form :label-position="labelPosition" label-width="80px">
            <el-form-item label="联系人">
              <el-input
                placeholder="请输入姓名"
                v-model="fromPop.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input
                placeholder="请输入联系方式"
                v-model="fromPop.tel"
              ></el-input>
            </el-form-item>
            <el-form-item prop="type">
              <el-checkbox-group v-model="fromPop.isdefault">
                <el-checkbox name="type">设置为默认地址</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">{{
                itemid ? "修改" : "确定新增"
              }}</el-button>
              <el-button @click="fahuoShow = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import { GoodsformCheck, BoxformCheck } from "./fromCheck.js"; //商品表单校验
export default {
  mixins: [GoodsformCheck, BoxformCheck],
  data() {
    return {
      // itemWrap: this.$route.query.itemWrap,
      itemWrap: JSON.parse(sessionStorage.getItem("itemWrap")),
      width: "420px",
      itemid: "",
      fahuoShow: false,
      labelPosition: "left",
      countLIst_S: {
        //发货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      fashow: false,
      FapopList: [],
      formData: {
        //增值服务展示
        totalExpense: "",
        amount: 0,
        feeItemDTOS: [],
      },
      calFBAFeeIDTOS: {
        //增值服务计算
        amount: 0,
        feeDTOList: [],
      },
      inwarehousetime: "", //送仓时间
      show1: ["1"],
      show2: ["1"],
      show3: ["1"],
      billType: null,
      imageNum: 1,
      imagesType: false,
      errorLabel: [],
      upUrl: "",
      excelVisible: false,
      // excelVisibleUpadte: false,
      transportTypeCode: null,
      goodstextShow: false,
      goodsTypeShow: false,
      GoodsCategory: true, //true是新增 false是修改
      Sgodname: "",
      // jack
      getLIstType: "",
      props: {
        value: "namec",
        label: "namec",
      },
      value: [],
      countLIst_T: {
        address: "",
        area: "",
        city: "",
        customerid: "",
        id: "",
        isdefault: null,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      showMydialog: false,
      jackCitylist: [],
      submitForm: {
        address: "",
        area: "",
        city: "",
        customerid: 0,
        id: 0,
        isdefault: false,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      edit: false,
      nameOrPhone: "",
      tableData: [],
      tempTableData: [],
      goodslisttotal: 0,
      goodstypelist: [],
      SonshowType: true,
      defaultParams: {
        label: "namec",
        value: "namec",
        children: "children",
      },
      shouaddressid: [],
      WaicountLIst: [],
      showType: false,
      addType: false,
      Timeshow: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      auto_fixed: false,
      cbm: null,
      tableData: [],
      Citydata: null,
      fromFABck: sessionStorage.getItem("fromFABck")
        ? JSON.parse(sessionStorage.getItem("fromFABck"))
        : {},
      toFABck: sessionStorage.getItem("toFABck")
        ? JSON.parse(sessionStorage.getItem("toFABck"))
        : {},
      PStablelist: [],
      searchPSname: "",
      FBATransmoney: {
        //运输费
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
        chargeWeight: "",
      },

      newTihuoarr: "", //需展示的提货地址
      todoorTime: null,
      THFdata: {
        checked: true,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer: "",
        maxKilometer: "",
      },
      pageNum: 1,
      ruleform: {
        formLIst: [
          {
            goodstypeid: "", //货物类型
            typeName: "", //货物类型名字
            weight: "", //重量
            length: "", //长
            width: "", //宽
            height: "", //高
            shopName: "", //商户号
            poTrackingNo: "", //po追踪号
            fbxBoxNo: "", //箱号
            cbm: 0,
            goodsDTOList: [],
          },
        ],
      },
      contactype2: "",
      dialogFormVisible: false,
      totalMolist: [],
      clickPsitem: {}, //当前点击收货地址item
      addgoodform: {
        id: "",
        brand: "",
        customerid: "",
        declaredValue: "",
        goodstypeid: "",
        hsCode: "",
        materialc: "",
        materiale: "",
        namec: "",
        namee: "",
        purposec: "",
        purposee: "",
        model: "",
        salesUrl: "",
        isHasBattery: false,
        isPowderLiquid: false,
        isHasMagnetic: false,
        picUrl: "",
      },
      setLIstdata: [],
      thatGoodslist: [],
      goodsLabel: [],
      ThatgoodsID: "",
      BoxWrapindex: null,
      activeLIst: [],
      thatindexgslist: [],
      fromPop: {
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: true,
        name: "",
        tag: "",
        tel: "",
      },
      ssqnames: [],
      imageUrl: "",
    };
  },
  watch: {},
  computed: {
    getBoxpcs() {
      let Totalpcs = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        item.goodsDTOList.forEach((_item) => {
          Totalpcs += _item.num;
        });
      });
      return Totalpcs;
    },
    getboxwhere() {
      //计算总体积
      let Totalcbm = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        Totalcbm += item.cbm;
      });
      return Totalcbm.toFixed(2);
    },
    getboxWeight() {
      let TotalWeight = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        TotalWeight += +item.weight;
      });
      return TotalWeight.toFixed(2);
    },
    activeName() {
      let activeName = [];
      this.ruleform.formLIst.forEach((item, index) => {
        activeName.push(index);
      });
      this.activeLIst = activeName;
      return activeName;
    },
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      FBATransmoney = this.FBATransmoney.cnyamount
        ? +this.FBATransmoney.cnyamount
        : 0;
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      Totalmoney = FBATransmoney + THFmoney + this.calFBAFeeIDTOS.amount;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      this.calFBAFeeIDTOS.feeDTOList.forEach((item) => {
        totalFeiyong.push(JSON.parse(JSON.stringify(item)));
      });
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    // 取消弹框
    handleClose() {
      this.goodstextShow = false;
      this.$refs["addgoodform"].clearValidate();
    },
    // 上传图片
    delImg() {
      //清空图片
      this.$refs.uploadDemo.clearFiles();
      this.addgoodform.picUrl = "";
      this.addgoodform.file = null;
    },

    isPhone(num) {
      let mPattern = /^1[34578]\d{9}$/;
      return mPattern.test(num);
    },

    onSubmit() {
      //新增发货
      if (!this.isPhone(this.fromPop.tel))
        return this.$message({ message: "请输入正确的手机号码" });
      let params = {
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id
        id: this.itemid,
        isdefault: this.fromPop.isdefault,
        name: this.fromPop.name,
        tag: "",
        tel: this.fromPop.tel,
      };
      this.axios.post(`/customer/addOrUpdateShipper`, params).then((res) => {
        // console.log(res);
        if (res.data.code == "200") {
          this.$message({ message: "成功", type: "success" });
          this.fahuoShow = false;
          this.getFadata();
        } else {
          this.$message(res.data.message);
        }
      });
    },
    UpItem(item) {
      //修改发货
      this.itemid = item.id;
      this.ssqnames = [];
      this.fahuoShow = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
    },
    addNewpop() {
      this.fahuoShow = true;
      this.itemid = "";
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.ssqnames = [];
      this.fromPop.address = "";
    },
    rowFaset(e) {
      // console.log("e: ", e);
      this.fashow = false;
      this.countLIst_S = e;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getgoodsData();
    },
    Getdown() {
      //下载模板
      this.axios
        .get(`/busFbx/downFBXBoxGoodsTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          // console.log(res);
          if (res.status) {
            let a = document.createElement("a");
            let blob = new Blob([res.data]);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "商品模板.xls");
            a.click();
            URL.revokeObjectURL(objectUrl); // 释放内存
          } else {
          }
        })
        .catch((res) => {});
    },
    clickme(item) {
      // console.log(item);
    },
    handleOPen(index) {
      // console.log(index);
    },
    goodsEdit(index, item) {
      // console.log(item);
      this.GoodsCategory = false;
      this.goodstextShow = true;
      this.addgoodform.customerid = this.sessionGetUserInfo().customerid; //客户id,
      this.addgoodform.id = item.id;
      this.addgoodform.brand = item.brand;
      this.addgoodform.declaredValue = item.declaredValue;
      this.addgoodform.goodstypeid = item.goodstypeid;
      this.addgoodform.hsCode = item.hsCode;
      this.addgoodform.materialc = item.materialc;
      this.addgoodform.materiale = item.materiale;
      this.addgoodform.namec = item.namec;
      this.addgoodform.namee = item.namee;
      this.addgoodform.purposec = item.purposec;
      this.addgoodform.purposee = item.purposee;
      this.addgoodform.model = item.model;
      this.addgoodform.salesUrl = item.salesUrl;
      this.addgoodform.isHasBattery = item.isHasBattery;
      this.addgoodform.isPowderLiquid = item.isPowderLiquid;
      this.addgoodform.isHasMagnetic = item.isHasMagnetic;
      this.addgoodform.file = "";
      this.addgoodform.picUrl = item.picUrl;
    },
    handleAvatarChange(file) {
      //图片上传
      this.delImg(); //清空文件
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.raw.size / 1024 / 1024 < 0.5;
      if (!isPNG && !isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 200kb!");
        return false;
      } else if (isLt2M && (isPNG || isJPG)) {
        this.imageFile = file;
        this.addgoodform.picUrl = URL.createObjectURL(file.raw);
        this.addgoodform.file = file.raw;
        return isLt2M && (isPNG || isJPG);
      }
    },
    addgoodtext(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            brand: this.addgoodform.brand,
            customerid: this.sessionGetUserInfo()
              .customerid, //客户id,
            declaredValue: this.addgoodform.declaredValue,
            file:
              typeof this.addgoodform.file == "undefined"
                ? null
                : this.addgoodform.file,
            goodstypeid: this.addgoodform.goodstypeid,
            hsCode: this.addgoodform.hsCode,
            id: this.addgoodform.id,
            isHasBattery: this.addgoodform.isHasBattery,
            isHasMagnetic: this.addgoodform.isHasMagnetic,
            isPowderLiquid: this.addgoodform.isPowderLiquid,
            materialc: this.addgoodform.materialc,
            model: this.addgoodform.model,
            namec: this.addgoodform.namec,
            namee: this.addgoodform.namee,
            picUrl: this.addgoodform.picUrl,
            purposec: this.addgoodform.purposec,
            salesUrl: this.addgoodform.salesUrl,
            towarehouseid: this.toFABck.id,
          };
          const formData = new FormData();
          for (const key in params) {
            formData.append(key, params[key]);
          }
          this.axios
            .post(`/busFbx/addOrUpdateFbxCustomerGoodsCategory`, formData, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            })
            .then((res) => {
              if (res.data.code == "200") {
                // this.addgoods();
                this.goodstextShow = false;
                this.getgoodsData();
                this.$message({
                  message: "成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    delGoodItem(index, item) {
      this.$confirm("确定删除此商品信息吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: item.id,
          };
          this.axios
            .post(
              `/busFbx/deleteFbxCustomerGoodsCategory`,
              qs.stringify(params)
            )
            .then((res) => {
              if (res.data.code == "200") {
                this.goodstextShow = false;
                this.getgoodsData();
              } else {
              }
            })
            .catch((res) => {});
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //新增商品信息
    addgoods() {
      this.goodstextShow = true;
      this.GoodsCategory = true;
      this.addgoodform.id = "";
      this.addgoodform.brand = "";
      this.addgoodform.customerid = "";
      this.addgoodform.declaredValue = "";
      this.addgoodform.goodstypeid = "";
      this.addgoodform.hsCode = "";
      this.addgoodform.materialc = "";
      this.addgoodform.materiale = "";
      this.addgoodform.namec = "";
      this.addgoodform.namee = "";
      this.addgoodform.purposec = "";
      this.addgoodform.purposee = "";
      this.addgoodform.sku = "";
      this.addgoodform.isHasBattery = false;
      this.addgoodform.isPowderLiquid = false;
      this.delImg();
    },
    changegoods(index) {
      this.Sgodname = "";
      this.thatindexgslist = [];
      if (this.ruleform.formLIst[index].goodsDTOList.length > 0) {
        //if 当前箱子内有货物
        this.ruleform.formLIst[index].goodsDTOList.forEach((item) => {
          this.thatindexgslist.push(item);
        });
      } else {
        this.thatindexgslist = [];
      }
      // console.log(this.thatindexgslist);
      this.BoxWrapindex = index;
      this.getgoodsData();
      this.goodsTypeShow = true;
    },
    handleSelectionChange(val) {
      this.thatGoodslist = val;
      // console.log(val);
    },
    setGoodspush() {
      if (this.thatGoodslist.length == 0) return this.$message("请选择商品");
      let newarray = this.thatindexgslist.concat(this.thatGoodslist);
      let idlist = [];
      newarray.forEach((item) => {
        idlist.push(item.goodstypeid);
      });
      idlist = [...new Set(idlist)];
      if (idlist.length > 1)
        return this.$message("单箱内只能放入同一种货物类型");

      let arr1 = JSON.parse(
        JSON.stringify(this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList)
      );
      this.thatGoodslist.forEach((item) => {
        arr1.push(item);
      });

      let newArr = [];
      arr1.forEach((el) => {
        const result = newArr.findIndex((ol) => {
          return el.id === ol.id;
        });
        if (result !== -1) {
          newArr[result].num = newArr[result].num + el.num;
        } else {
          newArr.push(el);
        }
      });

      if (this.toFABck.countryCode == "SA") {
        if (newArr.length > 3)
          return this.$message("单箱子内商品类型不能超过3件");
      }
      this.goodsTypeShow = false;
      this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList = newArr;
      this.ruleform.formLIst[this.BoxWrapindex].goodstypeid =
        newArr[0].goodstypeid;
      this.ruleform.formLIst[this.BoxWrapindex].typeName = newArr[0].goodstype;
      this.getFBATrans();
    },
    getgoodsData(name) {
      //获取商品列表
      let params = {
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id,
        goodstypeid: this.ThatgoodsID,
        name: name,
        towarehouseid: this.toFABck.id,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      this.axios
        .post(`/busFbx/getFbxCustomerGoodsCategoryList`, params)
        .then((res) => {
          if (res.data.code == "200") {
            // console.log(res);
            res.data.data.list.forEach((item) => {
              this.$set(item, "num", 1);
            });
            this.goodsLabel = res.data.data.list;
            this.goodslisttotal = res.data.data.total;
          } else {
          }
        })
        .catch((res) => {});
    },
    //-----------
    getGoodstypelist() {
      //商品类型
      let params = {
        warehouseId: this.toFABck.id,
      };
      this.axios
        .get(`/filedata/findFBAGoodTypeList?warehouseId=${this.toFABck.id}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.goodstypelist = res.data.datas;
          } else {
          }
        })
        .catch((res) => {});
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    isSize(val) {
      val = val.replace(/[^0-9]/gi, "");
      return val;
    },
    isnumber(val) {
      val = val.replace(/\d+(\.\d{0,2})?/, "");
      return val;
    },

    changeTi() {
      this.THFdata.checked != this.THFdata.checked;
      if (this.THFdata.checked) {
        this.getTimoney();
      }
    },
    pathToNext(formName) {
      let PathCBM = 0;
      let flag = true;
      let fromArr = this.ruleform.formLIst;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            fromArr.forEach((item, index) => {
              item.cbm = (item.length * item.width * item.height) / 1000000;
              PathCBM += parseFloat(+item.cbm);

              if (item.goodsDTOList.length == 0)
                throw this.$message({
                  message: `请添加${index + 1}号箱子内商品信息`,
                });
              item.goodsDTOList.forEach((_item) => {
                if (_item.num == 0 || _item.num == null) {
                  throw this.$message({ message: `添加的商品数量不能为0` });
                }
                if (!_item.declaredValue)
                  throw this.$message({ message: `请添加商品货值` });
                if (_item.declaredValue <= 0)
                  throw this.$message({ message: `货值必须大于0` });
              });
            });
            const standardNameList = fromArr.map(
              (standard) => standard.fbxBoxNo
            );
            if (new Set(standardNameList).size != standardNameList.length) {
              throw this.$message({ message: `箱号存在重复请检查` });
            }
          } catch (err) {
            File = false;
          }
          if (File) {
            if (this.billType && this.toFABck.countryCode == "SA") {
              let newArray = JSON.parse(JSON.stringify(this.ruleform.formLIst));
              newArray.forEach((item, index) => {
                item.fbxBoxNo = item.fbxBoxNo.substr(0, 12);
              });
              for (var i = 0; i < newArray.length - 1; i++) {
                for (var j = i + 1; j < newArray.length; j++) {
                  if (newArray[i].fbxBoxNo === newArray[j].fbxBoxNo) {
                    if (newArray[i].shopName !== newArray[j].shopName)
                      return this.$message({
                        message: this.$createElement("p", null, [
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${i + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `和`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${j + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱PO号相同，请填写相同的`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<商铺号>"
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<货件追踪号>"
                          ),
                        ]),
                      });
                    if (newArray[i].poTrackingNo !== newArray[j].poTrackingNo)
                      return this.$message({
                        message: this.$createElement("p", null, [
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${i + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `和`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${j + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱PO号相同，请填写相同的`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<商铺号>"
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<货件追踪号>"
                          ),
                        ]),
                      });
                  }
                }
              }
            }

            sessionStorage.setItem(
              "boxLIst",
              JSON.stringify(this.ruleform.formLIst)
            ); //商品信息
            sessionStorage.setItem("THFdata", JSON.stringify(this.THFdata)); //提货费
            sessionStorage.setItem(
              "FBATransmoney",
              JSON.stringify(this.FBATransmoney)
            ); //运输费
            if (!this.countLIst_S.name)
              return this.$message("请选择发货联系人");
            if (!this.countLIst_S.tel)
              return this.$message("请输入发货人联系电话");
            if (this.THFdata.checked) {
              //如果勾选了提货
              if (!this.countLIst_T.parvince)
                return this.$message("请选择上门提货地址");
              if (this.todoorTime == null)
                return this.$message("请选择上门提货时间");
              this.onToNext();
            } else {
              //送货到仓
              if (!this.inwarehousetime) return this.$message("请选择送仓日期");
              this.onToNext();
            }
          }
        } else {
          flag = false;
          return false;
        }
      });
    },
    onToNext() {
      //提交订单
      // if (this.FBATransmoney.amount == 0)
      //   return this.$message({ message: "计费过大不允许下单", type: "error" });
      const loading = this.$loading({
        lock: true,
        text: "下单中请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let that = this;
      let deliveryFbxAddressDTO = {
        getgoodsname: this.countLIst_T ? this.countLIst_T.name : "",
        getgoodstel: this.countLIst_T ? this.countLIst_T.tel : "",
        getgoodsprovince: this.countLIst_T ? this.countLIst_T.parvince : "",
        getgoodscity: this.countLIst_T ? this.countLIst_T.city : "",
        getgoodsarea: this.countLIst_T ? this.countLIst_T.area : "",
        getgoodsaddress: this.countLIst_T ? this.countLIst_T.address : "",
        getremarks: this.getgoodsremarks, //提货备注
      };
      let toFABck = JSON.parse(sessionStorage.getItem("toFABck")); //送仓地址
      let recwarehouseDTO = {
        recgoodscity: toFABck.city,
        recgoodscountry: toFABck.country,
        recremarks: this.recgoodremarks,
        recwarehouseaddress: toFABck.address,
        recwarehousecode: toFABck.namec,
      };
      let params = {
        busFbxjobsBeforeBoxDTOList: this.ruleform.formLIst,
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id
        delgoodsname: this.countLIst_S ? this.countLIst_S.name : "",
        delgoodstel: this.countLIst_S ? this.countLIst_S.tel : "",
        deliveryFbxAddressDTO: deliveryFbxAddressDTO,
        delremarks: "",
        finaArapFbxBeforeDTOList: that.formData.feeItemDTOS, //增值服务
        finaArapFbxBeforeTHFDTO: this.THFdata,
        finaArapFbxBeforeYSFDTO: this.FBATransmoney, //运输费
        fromCityId: JSON.parse(sessionStorage.getItem("fromFABck")).id, //起运城市id
        inwarehouseTime: this.inwarehousetime,
        isgetgoodstodoor: this.THFdata.checked,
        productPriceHeaderId: this.$route.query.productPriceHeaderId,
        recwarehouseDTO: recwarehouseDTO,
        remarks: "",
        saleid: this.sessionGetUserInfo().salesid,
        source: "WEB",
        todoordate: this.todoorTime,
        towarehouseid: this.toFABck.id,
        transportTypeCode: JSON.parse(
          sessionStorage.getItem("transportTypeCode")
        ),
      };
      this.axios
        .post(`/busFbx/createFbxjobsBefore`, params)
        .then((res) => {
          // console.log("下单: ", res);
          if (res.data.code == "200") {
            // console.log(res.data.data.innos);
            loading.close();
            this.$router.push({
              name: "FbaorderSuccess",
              query: {
                state: 1,
                innos: res.data.data.innos,
                nos: res.data.data.innos,
                isFastOrder: false,
              },
            });
          } else {
            loading.close();
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 返回上一层
    // pathToback() {
    //   // this.$router.go(-1);
    //   // this.$router.push({
    //   //   path: "/",
    //   //   query:{
    //   //     podlandId:JSON.parse(sessionStorage.getItem("toFABck")).id,
    //   //     pollandId:JSON.parse(sessionStorage.getItem("fromFABck")).id,
    //   //     Sonindex:0,
    //   //     whereCountryid:JSON.parse(sessionStorage.getItem("whereCountryid")),
    //   //   }
    //   // });
    // },
    getShowcount() {
      let that = this;
      let params = {};
      params = {
        countryId: this.$route.query.whereIDlist[0],
      };
      this.axios
        .post(`/FBAfee/getFBAFeeItems`, qs.stringify(params))
        .then((res) => {
          // console.log("res: ", res);
          if (res.data.code == "200") {
            that.formData.feeItemDTOS = res.data.datas;
            // console.log("增值服务: ", that.formData.feeItemDTOS);
          } else {
          }
        })
        .catch((res) => {});
    },
    getFBATrans() {
      //获取运输费
      this.loadin = true;
      let that = this;
      let boxDTOS = [];
      this.ruleform.formLIst.forEach((item, index) => {
        let goodItem = {
          goodsTypeId: 0,
          height: 0,
          length: 0,
          weight: 0,
          width: 0,
        };
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.height = item.height;
        goodItem.length = item.length;
        goodItem.width = item.width;
        goodItem.weight = item.weight;
        boxDTOS.push(goodItem);
      });

      let params = {
        feeCode: "QBHYF",
        pollandId: JSON.parse(sessionStorage.getItem("fromFABck")).id, //起运地id,
        podlandId: JSON.parse(sessionStorage.getItem("toFABck")).id, //目的地仓库
        customerId: this.sessionGetUserInfo()
          .customerid, //客户id
        boxDTOS: boxDTOS,
        transportTypeCode: JSON.parse(
          sessionStorage.getItem("transportTypeCode")
        ),
        productPriceHeaderId: this.$route.query.productPriceHeaderId,
        isgetgoodstodoor: this.THFdata.checked,
      };
      this.axios
        .post(`/FBAfee/getFBATransportFee`, params)
        .then((res) => {
          // console.log("运输费", res);
          if (res.data.code == "200") {
            that.FBATransmoney.price = res.data.data.price;
            that.FBATransmoney.currency = res.data.data.currency;
            that.FBATransmoney.cnyprice = res.data.data.price;
            that.FBATransmoney.piece = 1;
            that.FBATransmoney.amount = res.data.data.amount;
            that.FBATransmoney.cnyamount = res.data.data.cnyamount;
            that.FBATransmoney.goodsTypeFeeDTOS =
              res.data.data.goodsTypeFeeDTOS;
            that.FBATransmoney.chargeWeight = res.data.data.chargeWeight;
          } else {
            that.FBATransmoney.cnyamount = 0;
            that.FBATransmoney.amount = 0;
            that.FBATransmoney.price = "";
            that.FBATransmoney.currency = "";
            that.FBATransmoney.cnyprice = "";
            that.FBATransmoney.goodsTypeFeeDTOS = [];
          }
        })
        .catch((res) => {});
    },
    // 设为默认
    setDefault(item) {
      if (item.isdefault) {
        return this.$message.info("已经是默认地址");
      }
      this.axios
        .post(`/customer/updateAddressDefault?addressId=${item.id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.getPeopletable();
            this.$message.success("设置成功！");
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },
    Changehandle(items) {
      //计算增值服务
      this.$refs["ruleform"].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            this.ruleform.formLIst.forEach((item, index) => {
              if (item.goodsDTOList.length == 0) {
                items.checked = false;
                throw this.$message({
                  message: `请添加${index + 1}号箱子内商品信息`,
                });
              }
              item.goodsDTOList.forEach((_item) => {
                if (_item.num == 0 || _item.num == null) {
                  throw this.$message({ message: `添加的商品数量不能为0` });
                }
                if (!_item.declaredValue)
                  throw this.$message({ message: `请添加商品货值` });
              });
            });
          } catch (err) {
            File = false;
          }
          if (File) {
            let that = this;
            let params = {};
            params = {
              busFbxjobsBeforeBoxDTOList: this.ruleform.formLIst,
              countryId: this.$route.query.whereIDlist[0], //国家id
              feeItemDTOList: this.formData.feeItemDTOS,
            };
            this.axios
              .post(`/FBAfee/calFBAFeeItems`, params)
              .then((res) => {
                // console.log("res: ", res);
                if (res.data.code == "200") {
                  // let Newarray = res.data.data.feeItemDTOList;
                  that.calFBAFeeIDTOS.feeDTOList = res.data.data.feeItemDTOList;
                  that.calFBAFeeIDTOS.amount = res.data.data.amount;
                  // this.formData.feeItemDTOList.forEach((item, index) => {
                  //   if (Newarray[index].feeCode == item.feeCode) {
                  //     item.amount = Newarray[index].amount;
                  //     item.calDesc = Newarray[index].calDesc;
                  //   }
                  // });
                } else {
                }
              })
              .catch((res) => {});
          }
        } else {
          items.checked = false;
          console.log("error submit!!");
          return false;
        }
      });

      //计算费用
    },
    getTimoney() {
      //获取提货费
      let that = this;
      let weight = 0,
        cbm = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        item.cbm = (item.length * item.width * item.height) / 1000000;
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      let params = {};

      params = {
        province: this.countLIst_T.parvince, //省 name
        city: this.countLIst_T.city, //市 name
        area: this.countLIst_T.area, //区 name
        customerId: this.sessionGetUserInfo()
          .customerid, //客户id
        feeCode: "THF",
        inWarehouseId: JSON.parse(sessionStorage.getItem("fromFABck")).id,
        weight: weight,
        cbm: cbm,
        cityId: JSON.parse(sessionStorage.getItem("fromFABck")).id,
      };
      this.axios
        .post(`/FBAfee/getFBAPickUpFee`, params)
        .then((res) => {
          // console.log(res.data.data);
          if (res.data.code == "200") {
            if (res.data.data) {
              that.THFdata.price = res.data.data.price; //价格
              that.THFdata.currency = res.data.data.currency; //币种
              that.THFdata.cnyprice = res.data.data.cnyprice; //--隐藏单价
              that.THFdata.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
              that.THFdata.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
              that.THFdata.amount = res.data.data.price;
              that.THFdata.maxKilometer = res.data.data.maxKilometer;
              that.THFdata.minKilometer = res.data.data.minKilometer;
            } else {
              that.THFdata.price = null;
              that.THFdata.currency = "";
              that.THFdata.cnyprice = null;
              that.THFdata.amount = null;
            }
          } else {
          }
        })
        .catch((res) => {});
    },
    clone(box) {
      // console.log("box: ");

      this.$refs["ruleform"].validate((valid) => {
        let boxItem = JSON.parse(JSON.stringify(box));
        boxItem.fbxBoxNo = "";
        if (valid) {
          this.ruleform.formLIst.push(JSON.parse(JSON.stringify(boxItem)));
          this.getTimoney(); //重新计算提货费
          this.getFBATrans(); //重新计算运输费
        } else {
          this.$message({
            type: "info",
            message: "请填充完整箱子信息",
          });
          return false;
        }
      });
    },
    DeleteTitem(index, row) {
      let that = this;
      this.$confirm("确定删除该联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getPeopletable();
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            this.ruleform.formLIst.forEach((item, index) => {
              if (item.goodsDTOList.length == 0)
                throw this.$message({
                  message: `请添加${index + 1}号箱子内商品信息`,
                });
              item.goodsDTOList.forEach((_item) => {
                if (_item.num == 0 || _item.num == null) {
                  throw this.$message({ message: `添加的商品数量不能为0` });
                }
                if (!_item.declaredValue)
                  throw this.$message({ message: `请添加商品货值` });
              });
            });
          } catch (err) {
            File = false;
          }
          if (File) {
            this.activeName = [];
            this.ruleform.formLIst.push({
              goodstypeid: "", //货物类型
              typeName: "",
              weight: "", //重量
              length: "", //长
              width: "", //宽
              height: "", //高
              shopName: "", //商户号
              poTrackingNo: "", //po追踪号
              fbxBoxNo: "", //箱号
              cbm: 0,
              goodsDTOList: [],
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    delBoxgood(index, _index) {
      //删除箱子内某个商品
      this.ruleform.formLIst[index].goodsDTOList.splice(_index, 1);
    },
    handleDelete(index) {
      //删除箱子信息
      this.$confirm("确定删除该箱子信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ruleform.formLIst.splice(index, 1);
          this.getFBATrans();
          this.getTimoney();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    getProvinces() {
      //获取国外地址
      let customerid = this.sessionGetUserInfo().customerid;
      this.axios
        .post(`/filedata/findThirdLevelAddress`)
        .then((res) => {
          this.WaicountLIst = res.data.datas;
        })
        .catch((res) => {});
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = this.sessionGetUserInfo().customerid;
      this.axios
        .get(`/customer/addressListForFBADelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.tableData = res.data.datas;
            this.tempTableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => {});
    },
    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height =
          document.getElementsByClassName("wrap_R")[0].offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },

    // -------------------------弹窗地址-----------------------
    // jack methods start
    // 获取省市区列表
    // 关闭弹窗
    closeMyDialog() {
      if (this.edit) {
        this.$confirm("当前为编辑状态,是否关闭?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.showMydialog = false;
            this.showAdd(false);
          })
          .catch((res) => {});
      } else {
        this.showMydialog = false;
      }
    },
    // 显示弹窗
    changeCheic(type) {
      this.getPeopletable(); //获取提货联系人
      this.showMydialog = true;
    },
    // 校验
    very() {
      if (!this.submitForm.name) {
        this.$message.info("联系人不能为空！");
        return false;
      }
      if (!this.submitForm.tel) {
        this.$message.info("手机号不能为空！");
        return false;
      }
      // 城市
      if (!this.submitForm.city) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info("详细地址不能为空！");
        return false;
      }
      if (this.submitForm.tag) {
        if (this.submitForm.tag.length > 10) {
          this.$message.info("标签长度不能超过十个字符");
          return false;
        }
      }

      return true;
    },
    // 显示新增
    showAdd(type) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }

      this.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
    },
    handleChange(value) {
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    getFadata() {
      //发货人
      let that = this;
      let customerId = this.sessionGetUserInfo().customerid;
      this.axios
        .get(`/customer/addressListForShipper/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.FapopList = res.data.datas;
            // console.log("FapopList: ", res.data.datas);
            // res.data.datas.forEach((item) => {
            //     if (item.isdefault) {
            //       this.countLIst_S = item;
            //     }
            //   });
            this.fashow = true;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];
      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    addAddr(id) {
      if (!this.very()) {
        return;
      }
      if (!this.submitForm.id) {
        delete this.submitForm.id;
      }
      let user = this.sessionGetUserInfo();
      // 新增
      this.submitForm.customerid = user.customerid;
      let path = "addOrUpdateDelivery";

      this.axios
        .post(`/customer/${path}`, this.submitForm, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.edit = false;
            this.value = [];
            this.getPeopletable();
            for (let key in this.submitForm) {
              this.submitForm[key] = "";
            }
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },
    // 点击行
    rowClick(r) {
      this.countLIst_T = r;
      sessionStorage.setItem("countLIst_T", JSON.stringify(this.countLIst_T));
      this.showMydialog = false;
      this.getTimoney(); //重新计算提货费
    },
    //  edit
    getPopList() {
      // 获取省市区列表
      let user = this.sessionGetUserInfo();
      this.axios
        .post(`/filedata/findDAndILevelAddress`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
    handleEdit(index, item) {
      this.value = [];
      let temp = JSON.stringify(item);
      this.submitForm = JSON.parse(temp);
      this.value.push(
        this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
      this.edit = true;
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      if (response.isSuccess) {
        this.$message.success(response.error);
        // this.getListByParam();
        return;
      }
      this.$message.info(response.error);
    },
    // 上传前
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限后缀xls文件");
        return false;
      }
    },
    //上传12
    uploadSectionFile(params) {
      let towarehouseid = JSON.parse(sessionStorage.getItem("toFABck")).id;
      // let boxNoType = 1;
      let form = new FormData();
      form.append("file", params.file);
      form.append("towarehouseid", towarehouseid);
      // form.append("boxNoType", boxNoType);
      this.axios
        .post(`/busFbx/uploadFbxJobsBoxInfo`, form)
        .then((res) => {
          if (res.data.code == -1) {
            this.errorLabel = res.data.data;
            this.$message.info(res.data.data);
          } else {
            this.ruleform.formLIst = res.data.datas;
            this.excelVisible = false;
            this.getTimoney(); //重新计算提货费
            this.getFBATrans(); //重新计算运输费
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // 19失败时的方法
    // handleErrorUpdate(err) {
    //   this.$message.info(err.data);
    // },
    // //19成功时的方法
    // handleSuccessUpdate(response) {
    //   if (response.isSuccess) {
    //     this.$message.success(response.error);
    //     // this.getListByParam();
    //     return;
    //   }
    //   this.$message.info(response.error);
    // },
    // // 19上传前
    // handleBeforeUploadXls(file) {
    //   // 校验
    //   let legalName = ["xlsx", "xls"];
    //   // 拿到后缀名
    //   let name = file.name.substring(
    //     file.name.lastIndexOf(".") + 1,
    //     file.name.length
    //   );
    //   if (legalName.includes(name)) {
    //     // console.log(legalName.includes(name));
    //   } else {
    //     this.$message.info("文件格式不对，仅限后缀xls文件");
    //     return false;
    //   }
    // },

    // //上传 19
    // uploadSectionFileUpdate(params) {
    //   let towarehouseid = JSON.parse(sessionStorage.getItem("toFABck")).id;
    //   let boxNoType = 2;
    //   let form = new FormData();
    //   form.append("file", params.file);
    //   form.append("towarehouseid", towarehouseid);
    //   form.append("boxNoType", boxNoType);
    //   this.axios
    //     .post(`/busFbx/uploadFbxJobsBoxInfo`, form)
    //     .then((res) => {
    //       if (res.data.code == -1) {
    //         this.errorLabel = res.data.data;
    //         this.$message.info(res.data.data);
    //       } else {
    //         this.ruleform.formLIst = res.data.datas;
    //         // this.excelVisibleUpadte = false;
    //         this.getTimoney(); //重新计算提货费
    //         this.getFBATrans(); //重新计算运输费
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
  },
  created() {
    this.transportTypeCode = JSON.parse(
      sessionStorage.getItem("transportTypeCode")
    );
    // if (sessionStorage.getItem("FBATransmoney")) {
    //   //提货地址
    //   this.FBATransmoney = JSON.parse(sessionStorage.getItem("FBATransmoney"));
    // }
    // if (sessionStorage.getItem("countLIst_T")) {
    //   //提货地址
    //   this.countLIst_T = JSON.parse(sessionStorage.getItem("countLIst_T"));
    // }
    // if (sessionStorage.getItem("todoorTime")) {
    //   //提货时间
    //   this.todoorTime = sessionStorage.getItem("todoorTime");
    // }
    // if (sessionStorage.getItem("boxLIst")) {
    //   //箱子
    //   this.ruleform.formLIst = JSON.parse(sessionStorage.getItem("boxLIst"));
    // }
    // if (sessionStorage.getItem("THFdata")) {
    //   // 提货费
    //   this.THFdata = JSON.parse(sessionStorage.getItem("THFdata"));
    // }
  },
  mounted() {
    this.getGoodstypelist();
    this.getPopList();
    this.getShowcount();
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
    let toFABck = JSON.parse(sessionStorage.getItem("toFABck"));
    if (toFABck.type == 1 && toFABck.countryCode == "SA") {
      //需要校验
      this.billType = true; //显示 商铺号和追踪号
      this.moreNotOjb.Notponum[0].required = true;
      this.moreNotOjb.Notgoodsnum[0].required = true;
      this.moreNotOjb.Notboxnum[0].required = true;
    } else if (
      (toFABck.type == 1 && toFABck.countryCode != "SA") ||
      (toFABck.type == 1 && toFABck.countryCode != "US")
    ) {
      this.billType = true;
      this.moreNotOjb.Notponum[0].required = true; //追踪号
      this.moreNotOjb.Notgoodsnum[0].required = false; //商铺号
      this.moreNotOjb.Notboxnum[0].required = true; //箱号校验
    }
    // 商品信息校验
    if (toFABck.countryCode == "US" || toFABck.countryCode == "CA") {
      //美国、加拿大
      this.goodsRules.salesUrl[0].required = false;
    }
    if (toFABck.countryCode == "AE") {
      //阿联酋
      this.goodsRules.brand[0].required = false;
      this.goodsRules.hsCode[0].required = false;
      this.goodsRules.purposec[0].required = false;
      this.goodsRules.salesUrl[0].required = false;
      this.goodsRules.materialc[0].required = false;
      this.goodsRules.model[0].required = false;
      this.goodsRules.picUrl[0].required = false;
    }
    if (toFABck.countryCode == "SA") {
      //沙特
      this.goodsRules.hsCode[0].required = false;
      this.goodsRules.salesUrl[0].required = false;
    }
  },
};
</script>
<style scoped>
.helper {
  width: 100%;
  height: 15%;
  color: #FF4D01;
  align-content: center;
  text-align: center;
  font-size: 20px;
}
.box-card {
  position: relative;
}
.cardWrap {
  padding: 0 0 0 44px;
}
.card_header {
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
}
.card_count {
  padding: 20px 20px 0 20px;
}
.addStyle {
  padding: 10px 0;
  box-sizing: border-box;
}
.fa_logo {
  width: 100%;
  float: left;
  text-align: left;
}
.header_logo {
  height: 30px;
  line-height: 30px;
  margin-left: 4px;
  color: #fff;
  position: absolute;
  top: 11px;
  right: 0px;
  border-radius: 20px 0px 0px 20px;
  background: #FF4D01;
  font-weight: bold;
  border-style: none none solid solid;
  /* border-color: #83a4fe;
  border-width: 3px; */
  z-index: 999;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.boxindex {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #FF4D01;
  text-align: center;
  top: 10px;
  left: -17px;
  color: #ffffff;
  line-height: 25px;
  font-size: 18px;
  text-align: center;
}
.cloneType {
  color: #ffffff;
  float: left;
}

.deleteBtn {
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-left: 15px;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.goodsTextFlex {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 880px;
}
.goodsValue >>> .el-input__inner {
  border-radius: 0 !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
  border: none;
  border-bottom: 1px solid #9999;
}
.handNumber >>> .el-input__inner {
  border-radius: 20px !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
}
/* 去除 number类型 的自带默认箭头 */
.handNumber >>> .el-input__inner::-webkit-outer-spin-button,
.handNumber >>> .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.handNumber >>> .el-input__inner[type="number"] {
  -moz-appearance: textfield;
}
.goodsTypeShow >>> .el-dialog__body {
  padding: 0 !important;
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}
.card_header >>> .el-form-item {
  margin-bottom: 0px !important;
}
.upload-demo >>> .el-upload-dragger {
  width: 265px !important;
}

.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.goodLi {
  width: 100%;
  height: 30px;
  padding: 0px;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.center_wrap {
  padding-top: 30px;
  width: 1200px;
  margin: 0 auto;
}
.semillWrap >>> .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  width: 100% !important;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 15px 0 15px 65px;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.wrap_l {
  float: left;
  width: 875px;
  background: #ffffff;

  padding: 0 35px;
  box-sizing: border-box;
}
.leftItem {
  width: 100%;
  float: left;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.3);
  border-radius: 20px;
  margin-bottom: 24px;
  overflow: hidden;
}
.wrap_R {
  float: right;
  width: 320px;
  max-height: 95vh;
  overflow: auto;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  /* position: sticky;
  top: 0px; */
}

/* jack css start  */
/* 弹窗遮罩层 */
.dialogCover {
  width: 100%;
  height: 100%;
  background-color: rgba(88, 85, 85, 0.37);
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
}
/* 弹窗 */
.myDialog {
  min-height: 350px;
  width: 50%;
  height: 50%;
  min-height: 400px;
  width: 50%;
  height: 50%;
  background-color: #fff;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  border-radius: 20px;
  padding: 20px;

  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
}
/* 进一步查价 */

/* jack css end  */
.wrap_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.Shipment {
  position: absolute;
  top: 20px;
}

.ShipmentID {
  position: absolute;
  top: 66px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewOrder/BillCargo.vue